/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

import "reflect-metadata";
import { enableProdMode } from "@angular/core";

import { platformBrowser } from "@angular/platform-browser";

import { AppModule } from "./html5-client/app.module";

enableProdMode();
platformBrowser().bootstrapModule(AppModule);
